import Reflux from 'reflux';

export default {
  chatsStatuses: Reflux.createAction({ sync: false }),
  updateLastReadDate: Reflux.createAction({ sync: false }),
};
